import React from 'react';
import { Registration, RegistrationStatusEnum } from '../API';
import { Link } from 'react-router-dom';
import { Checkbox, Button } from '@uclaea/react-component-library';

interface AttendeeRowProps {
  attendee: Registration & { membership?: string; guests: number; checkedInCount: number; notes?: string };
  selected: boolean;
  onSelect: () => void;
  rowAction: number;
  onRowActionChange: (value: number) => void;
  onSave: () => void;
  disabled: boolean;
  formatDate: (dateString: string) => string;
  activeDropdownId: string | null;
  notesValue: string;
  onNotesChange: (val: string) => void;
}

const AttendeeRow: React.FC<AttendeeRowProps> = ({
  attendee,
  selected,
  onSelect,
  rowAction,
  onRowActionChange,
  onSave,
  disabled,
  formatDate,
  activeDropdownId,
  notesValue,
  onNotesChange,
}) => (
  <tr className="attendee-row">
    <td>
      <div className='input-row'>
        <Checkbox
          label=""
          checked={selected}
          onChange={onSelect}
          aria-label={`Select ${attendee.firstName} ${attendee.lastName}`}
        />
      </div>
    </td>
    <td>
      {attendee.submissionId ? (
        <Link to={`https://reports.support2.ucla.edu/reports/datacapture/Report.aspx?${attendee.live ? '' : 'Test=Y&'}Indiv=Y&SubmissionID=${attendee.submissionId}`}>
          {attendee.lastName}, {attendee.firstName}{!attendee.live && <b> - (TEST)</b>}
        </Link>
      ) : (
        <>
          {attendee.lastName}, {attendee.firstName}{!attendee.live && <b> - (TEST)</b>}
        </>
      )}
    </td>
    <td>{attendee.email}</td>
    <td>
      {attendee.dateCreated && attendee.dateCreated !== 'null' && attendee.dateCreated !== '' && new Date(attendee.dateCreated).getTime() > 0
        ? formatDate(attendee.dateCreated)
        : ' - '}
    </td>
    <td>
      {attendee.registrationStatus} {
        attendee.membership && attendee.membership !== null && attendee.membership !== ''
          ? (<b>({attendee.membership})</b>)
          : ''
      }
    </td>
    <td>{`${attendee.checkedInCount} / ${attendee.guests}`}</td>
    <td>
      <input
        type="text"
        className="notes-input"
        value={notesValue}
        onChange={e => onNotesChange(e.target.value)}
        placeholder="Add note..."
        disabled={disabled}
      />
    </td>
    <td className='hide-for-mobile'>
      <div className='actions-dropdown'>
        <select
          value={rowAction}
          onChange={e => onRowActionChange(Number(e.target.value))}
          disabled={disabled}
        >
          {attendee.registrationStatus === RegistrationStatusEnum.INVITED || attendee.guests === 0
            ? [...Array(9).keys()].map(count => (
              <option key={count} value={count}>{count}</option>
            ))
            : [...Array(attendee.guests + 1).keys()].map(count => (
              <option key={count} value={count}>{count}</option>
            ))
          }
        </select>
        <Button
          variant="primary"
          label="Save"
          onClick={onSave}
          disabled={disabled}
        />
      </div>
    </td>
    <td className='hide-for-desktop'></td>
    <td className='hide-for-desktop'>
      <div className='button-container'>
        {activeDropdownId === attendee.registrationId && <div></div>}
      </div>
    </td>
  </tr>
);

export default AttendeeRow;
